import React, { useEffect, useState } from 'react';
import { animate, motion, useMotionValue, useTransform } from 'framer-motion';
type ScoreRingProps = {
  score: number;
};
const SIZE = 220;
const STROKE = 1.5;
const RADIUS = (SIZE - STROKE * 2) / 2 - 6;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
export function ScoreRing({
  score
}: ScoreRingProps) {
  const progress = useMotionValue(0);
  const dashOffset = useTransform(progress, value => CIRCUMFERENCE - CIRCUMFERENCE * value / 100);
  const [displayed, setDisplayed] = useState(0);
  useEffect(() => {
    const controls = animate(progress, score, {
      duration: 2.2,
      ease: [0.22, 1, 0.36, 1],
      delay: 0.35,
      onUpdate: value => setDisplayed(Math.round(value))
    });
    return () => controls.stop();
  }, [progress, score]);
  return <div className="relative mx-auto" style={{
    width: SIZE,
    height: SIZE
  }} role="img" aria-label={`Skin Fresh Index: ${score} de 100`} data-id="element-126" data-mp="kueweq3clo04">
      <motion.svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`} className="-rotate-90" initial={{
      opacity: 0,
      scale: 0.94
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.1,
      ease: [0.22, 1, 0.36, 1]
    }} data-id="element-127" data-mp="1uvhm89dra4ka">
        <circle cx={SIZE / 2} cy={SIZE / 2} r={RADIUS} fill="none" stroke="#d7e2d2" strokeWidth={STROKE} data-id="element-128" data-mp="1kznydtul6on7" />
        <motion.circle cx={SIZE / 2} cy={SIZE / 2} r={RADIUS} fill="none" stroke="#63785a" strokeWidth={STROKE * 2} strokeLinecap="round" strokeDasharray={CIRCUMFERENCE} style={{
        strokeDashoffset: dashOffset
      }} data-id="element-129" data-mp="1b6764ua3lhln" />
      </motion.svg>

      <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-130" data-mp="s8mghkzieezz">
        <span className="font-serif text-6xl font-light leading-none text-warmgray-800 tabular-nums" data-id="element-131" data-mp="sapdwq2zraeq">
          {displayed}
        </span>
        <span className="mt-2 text-xs font-light tracking-[0.2em] text-warmgray-400" data-id="element-132" data-mp="e3m2pltmtq8z">
          / 100
        </span>
      </div>
    </div>;
}